import { z } from 'zod';

import { schemaEuropaceFahrzeugkauf } from './Fahrzeugkauf.schema';
import { schemaEuropaceFinanzbedarfRatenschutz } from './FinanzbedarfRatenschutz.schema';
import { schemaEuropaceFinanzierungswunsch } from './Finanzierungswunsch.schema';
import { schemaEuropaceFinanzierungszweck } from './Finanzierungszweck.schema';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#finanzbedarf

    {
        "fahrzeugkauf": Fahrzeugkauf,
        "finanzierungszweck": "UMSCHULDUNG" | "FAHRZEUGKAUF" | "MODERNISIEREN" | "FREIE_VERWENDUNG",
        "finanzierungswunsch": {
            "kreditbetrag": schemaBigDecimal,
            "laufzeitInMonaten": schemaInteger,
            "provisionswunschInProzent": schemaBigDecimal,
            "rateMonatlich": schemaBigDecimal,
            "ratenzahlungstermin": "MONATSENDE" | "MONATSMITTE"
        },
        "ratenschutzAntragsteller1": FinanzbedarfRatenschutz,
        "ratenschutzAntragsteller2": FinanzbedarfRatenschutz
    }

    fahrzeugkauf is only processed if the finanzierungszweck is set to FAHRZEUGKAUF
*/

export const schemaEuropaceFinanzbedarf = z.object({
    fahrzeugkauf: z.optional(schemaEuropaceFahrzeugkauf),
    finanzierungswunsch: z.optional(schemaEuropaceFinanzierungswunsch),
    finanzierungszweck: z.optional(schemaEuropaceFinanzierungszweck),
    ratenschutzAntragsteller1: z.optional(schemaEuropaceFinanzbedarfRatenschutz),
    ratenschutzAntragsteller2: z.optional(schemaEuropaceFinanzbedarfRatenschutz),
});

export type SchemaEuropaceFinanzbedarf = z.infer<typeof schemaEuropaceFinanzbedarf>;
